import React from 'react'
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldValues,
  Path,
} from 'react-hook-form'

import { AdultsPicker, AdultsPickerProps } from './fields/AdultsPicker'
import { BudgetPicker, BudgetPickerProps } from './fields/BudgetPicker'
import { DatesPicker, DatesPickerProps } from './fields/DatesPicker'
import { LocationPicker, LocationPickerProps } from './fields/LocationPicker'
import { CurrentFieldName, Inputs } from '../useFieldNavigator'
import { IDatesCalendarProps } from '../../../organisms/dates-calendar/dates-calendar'
import { MostBookedRegionType } from '../../../organisms/location-picker/location-picker.type'

type RenderContentModalProps = {
  currentField: CurrentFieldName
  field: ControllerRenderProps<FieldValues, string>
  locationProps: Omit<LocationPickerProps, 'field'>
  datesProps: Omit<DatesPickerProps, 'field'>
  adultsProps: Omit<AdultsPickerProps, 'field'>
  budgetProps: Omit<BudgetPickerProps, 'field'>
}
type ContentModalProps = {
  currentField: CurrentFieldName
  control: Control<FieldValues, any>
  name: Path<FieldValues>
  mostBookedRegions: MostBookedRegionType[]
  dateCalendarProps: IDatesCalendarProps
  onValid: (currentField: keyof Inputs) => () => void
}

const renderContentModal = ({
  currentField,
  field,
  locationProps,
  datesProps,
  adultsProps,
  budgetProps,
}: RenderContentModalProps) => {
  switch (currentField) {
    case 'location':
      return <LocationPicker field={field} {...locationProps} />
    case 'dates':
      return <DatesPicker field={field} {...datesProps} />
    case 'adults':
      return <AdultsPicker field={field} {...adultsProps} />
    case 'budget':
      return <BudgetPicker field={field} {...budgetProps} />

    default:
      return null
  }
}

export const ContentModal = ({
  control,
  currentField,
  name,
  mostBookedRegions,
  dateCalendarProps,
  onValid,
}: ContentModalProps) => {
  const props: Omit<RenderContentModalProps, 'field'> = {
    currentField,
    locationProps: {
      mostBookedRegions,
      onValid: onValid('location'),
    },
    datesProps: {
      control,
      dateCalendarProps,
      onValid: onValid('dates'),
    },
    adultsProps: {
      onValid: onValid('adults'),
    },
    budgetProps: {
      onValid: onValid('budget'),
    },
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={{}}
      render={({ field }) => (
        <div className='p-[20px]'>
          {renderContentModal({ field, ...props })}
        </div>
      )}
    />
  )
}
